var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns is-desktop" }, [
          _c("div", { staticClass: "column is-8 is-offset-2" }, [
            _c("h1", { staticClass: "title level" }, [
              _c("span", { staticClass: "flex" }, [
                _vm._v(_vm._s(_vm.$t("doctorRegister_title")))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-secondary",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout($event)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "form",
                {
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.submit($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-3" }, [
                      _c("h4", {
                        staticClass: "subtitle",
                        domProps: {
                          textContent: _vm._s(_vm.$t("doctor_legend"))
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-7" }, [
                      _c("div", { staticClass: "field has-text-centered" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleAvatarSelector(true)
                              }
                            }
                          },
                          [
                            _c("avatar", {
                              staticClass: "is-inline image is-96x96",
                              attrs: { avatar: _vm.newDoctor.avatar, name: "" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "is-size-7 has-text-grey is-block" },
                          [_vm._v(_vm._s(_vm.$t("click_to_change_avatar")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("first_name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.firstName,
                                      expression: "newDoctor.firstName"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "doctor.firstName"
                                    )
                                  },
                                  attrs: {
                                    name: "doctor.firstName",
                                    type: "text"
                                  },
                                  domProps: { value: _vm.newDoctor.firstName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "firstName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "doctor.firstName"
                                        ),
                                        expression:
                                          "errors.has('doctor.firstName')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("last_name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.lastName,
                                      expression: "newDoctor.lastName"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "doctor.lastName"
                                    )
                                  },
                                  attrs: {
                                    name: "doctor.lastName",
                                    type: "text"
                                  },
                                  domProps: { value: _vm.newDoctor.lastName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "lastName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "doctor.lastName"
                                        ),
                                        expression:
                                          "errors.has('doctor.lastName')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("contact_email_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newDoctor.contactEmail,
                                  expression: "newDoctor.contactEmail"
                                }
                              ],
                              class: {
                                input: true,
                                "is-danger": _vm.errors.has("contactEmail")
                              },
                              attrs: { name: "contactEmail", type: "email" },
                              domProps: { value: _vm.newDoctor.contactEmail },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newDoctor,
                                    "contactEmail",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("contactEmail"),
                                    expression: "errors.has('contactEmail')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("contactEmail"),
                                    expression: "errors.has('contactEmail')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("email_error")))]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("medical_practice_label")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("div", { staticClass: "select is-fullwidth" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.type,
                                      expression: "newDoctor.type"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.medicalPractices, function(type) {
                                  return _c(
                                    "option",
                                    { domProps: { value: type } },
                                    [_vm._v(_vm._s(_vm.$t("type_" + type)))]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("inami_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric|min:11|max:11",
                                  expression: "'required|numeric|min:11|max:11'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newDoctor.inami,
                                  expression: "newDoctor.inami"
                                }
                              ],
                              class: {
                                input: true,
                                "is-danger": _vm.errors.has("doctor.inami")
                              },
                              attrs: { name: "doctor.inami", type: "inami" },
                              domProps: { value: _vm.newDoctor.inami },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newDoctor,
                                    "inami",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.inami"),
                                    expression: "errors.has('doctor.inami')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.inami"),
                                    expression: "errors.has('doctor.inami')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("inami_error")))]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newDoctor.isRegulated,
                                expression: "newDoctor.isRegulated"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.newDoctor.isRegulated)
                                ? _vm._i(_vm.newDoctor.isRegulated, null) > -1
                                : _vm.newDoctor.isRegulated
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.newDoctor.isRegulated,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "isRegulated",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "isRegulated",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.newDoctor, "isRegulated", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("is_regulated_label"))
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "field",
                          class:
                            Object.keys(_vm.countries).length == 1
                              ? "is-hidden"
                              : ""
                        },
                        [
                          _c("label", {
                            staticClass: "label",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("DoctorProfile.country_label")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "control has-icon has-icons-right" },
                            [
                              _c("div", { staticClass: "select" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newDoctor.countryId,
                                        expression: "newDoctor.countryId"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.newDoctor,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(_vm.countries, function(country) {
                                    return _c("option", {
                                      domProps: {
                                        value: country.id,
                                        textContent: _vm._s(
                                          _vm.$t("Countries_" + _vm.countr.code)
                                        )
                                      }
                                    })
                                  }),
                                  0
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("language_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("div", { staticClass: "select" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.language,
                                      expression: "newDoctor.language"
                                    }
                                  ],
                                  attrs: { name: "doctor.language" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "language",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.languages, function(language, id) {
                                  return _c(
                                    "option",
                                    { domProps: { value: language.code } },
                                    [_vm._v(_vm._s(language.name))]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.language"),
                                    expression: "errors.has('doctor.language')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.language"),
                                    expression: "errors.has('doctor.language')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("doctor.language"))
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.newOffices, function(office, key) {
                    return _c("div", { key: key }, [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column is-3" }, [
                          _c("h4", {
                            staticClass: "subtitle",
                            domProps: {
                              textContent: _vm._s(_vm.$t("office_legend"))
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column is-7" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: office.name,
                                      expression: "office.name"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "offices." + key + ".name"
                                    )
                                  },
                                  attrs: {
                                    name: "offices." + key + ".name",
                                    type: "name"
                                  },
                                  domProps: { value: office.name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        office,
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "offices." + key + ".name"
                                        ),
                                        expression:
                                          "errors.has('offices.' + key + '.name')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-8" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("street_name_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.streetName,
                                          expression: "office.streetName"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".streetName"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".streetName",
                                        type: "streetName"
                                      },
                                      domProps: { value: office.streetName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "streetName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".streetName"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.streetName')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column is-4" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("street_number_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.streetNumber,
                                          expression: "office.streetNumber"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".streetNumber"
                                        )
                                      },
                                      attrs: {
                                        name:
                                          "offices." + key + ".streetNumber",
                                        type: "streetNumber"
                                      },
                                      domProps: { value: office.streetNumber },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "streetNumber",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".streetNumber"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.streetNumber')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-4" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("zip_code_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.zipCode,
                                          expression: "office.zipCode"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".zipCode"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".zipCode",
                                        type: "zipCode"
                                      },
                                      domProps: { value: office.zipCode },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "zipCode",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".zipCode"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.zipCode')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column is-8" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("locality_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.locality,
                                          expression: "office.locality"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".locality"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".locality",
                                        type: "locality"
                                      },
                                      domProps: { value: office.locality },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "locality",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".locality"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.locality')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("country_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "control" }),
                            _c(
                              "div",
                              {
                                class: {
                                  "select is-fullwidth": true,
                                  "is-danger": _vm.errors.has(
                                    "offices." + key + ".countryId"
                                  )
                                }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: office.countryId,
                                        expression: "office.countryId"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "is-block",
                                    attrs: {
                                      name: "offices." + key + ".countryId",
                                      disabled:
                                        Object.keys(_vm.countries).length == 1
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          office,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("select_country_label"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function(
                                      country,
                                      id
                                    ) {
                                      return _c("option", {
                                        domProps: {
                                          value: id,
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "Countries_" + _vm.countr.code
                                            )
                                          )
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p"),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "offices." + key + ".countryId"
                                    ),
                                    expression:
                                      "errors.has('offices.' + key + '.countryId')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("select_country_label")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("phone_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        regex: _vm.getPhoneRegex(key)
                                      },
                                      expression:
                                        "{\n                                                    required: true,\n                                                    regex: getPhoneRegex(key)\n                                                }"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: office.phone,
                                      expression: "office.phone"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "offices." + key + ".phone"
                                    )
                                  },
                                  attrs: {
                                    name: "offices." + key + ".phone",
                                    placeholder:
                                      _vm.getCurrentCountryPhonePrefix(office) +
                                      "...",
                                    type: "phone"
                                  },
                                  domProps: { value: office.phone },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        office,
                                        "phone",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "offices." + key + ".phone"
                                        ),
                                        expression:
                                          "errors.has('offices.' + key + '.phone')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "offices." + key + ".phone"
                                    ),
                                    expression:
                                      "errors.has('offices.' + key + '.phone')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("DoctorOffice.phone_error", {
                                      prefix: _vm.getCountryPhonePrefix(key)
                                    })
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          key != 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "button",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeOffice(key)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "close-circle" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("remove_office_button_label")
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-7 is-offset-3" }, [
                      _c("div", [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.acceptTerms,
                                expression: "acceptTerms"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { type: "checkbox", name: "acceptTerms" },
                            domProps: {
                              checked: Array.isArray(_vm.acceptTerms)
                                ? _vm._i(_vm.acceptTerms, null) > -1
                                : _vm.acceptTerms
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.acceptTerms,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.acceptTerms = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.acceptTerms = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.acceptTerms = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("accept_terms_label"))
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("acceptTerms"),
                                expression: "errors.has('acceptTerms')"
                              }
                            ],
                            staticClass: "help is-danger"
                          },
                          [_vm._v(_vm._s(_vm.$t("accept_terms_error")))]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.errors.any()
                    ? _c(
                        "div",
                        { staticClass: "notification is-danger mb-4" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("fields_are_missing")) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error
                    ? _c(
                        "div",
                        { staticClass: "notification is-danger mb-4" },
                        [
                          _c("button", {
                            staticClass: "delete",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteError($event)
                              }
                            }
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.error) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-7 is-offset-3" }, [
                      _c("div", { staticClass: "is-aligned-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addOffice($event)
                              }
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("add_office_button_label")
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            attrs: { disabled: _vm.errors.any() },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.submit($event)
                              }
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("register_button_label")
                                )
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ])
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.showAvatarSelector },
          on: {
            "update:active": function($event) {
              _vm.showAvatarSelector = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", attrs: { id: "avatars-modal-card" } },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(_vm._s(_vm.$t("doctorRegister_title")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "modal-card-body has-text-centered" },
                _vm._l(_vm.avatars, function(avatarPath, avatar) {
                  return _c(
                    "div",
                    {
                      staticClass: "is-inline-block mx-2 my-2",
                      class:
                        avatar == _vm.newDoctor.avatar
                          ? "selected-avatar"
                          : "unselected-avatar"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.selectAvatar(avatar)
                            }
                          }
                        },
                        [
                          _c("avatar", {
                            staticClass: "image is-96x96",
                            attrs: { avatar: avatar, name: avatarPath }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.toggleAvatarSelector(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel_button_label")))]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d6b239a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d6b239a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Register.vue
// module id = 619
// module chunks = 1